import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
const departmentApi = factory.get("department");
const job_titleApi = factory.get("job_title");

const initialState = {
  dialog: false,
  job_titles: {
    loading: false,
    form: {
      id: "",
      name: "",
      belongs_to: "",
    },
    list: [],
  },
  departments: {
    loading: false,
    loading_form: false,
    form: {
      id: "",
      name: "",
      manager_user_id: "",
      need_approval_over_time: false,
    },
    table: {
      data: [],
      total: 0,
    },
  },
  my_department_employees: {
    loading: false,
    list: [],
  },
};

export const departmentsJobTitlesSlice = createSlice({
  name: "departmentsJobTitles",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.dialog = !state.dialog;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setLoadingForm: (state) => {
      state.departments.loading_form = !state.departments.loading_form;
    },
    setDataTable: (state, { payload }) => {
      state[payload.key].table.data = payload.value.data;
      state[payload.key].table.total = payload.value.total;
    },
    setForm: (state, { payload }) => {
      const data = payload.data[0];

      state.departments.form.id = data.id;
      state.departments.form.name = data.name;
      state.departments.form.manager_user_id = data.manager_user_id;

      state.departments.form.belongs_to = data.belongs
        ? { id: data.belongs.id, name: data.belongs.name }
        : null;

      state.job_titles.list = data.job_title;
      state.departments.form.need_approval_over_time =
        data?.need_approval_over_time === 1 ||
        data?.need_approval_over_time === "1";
    },
    setJobTitle: (state, { payload }) => {
      state.job_titles.form.id = payload.id;
      state.job_titles.form.name = payload.name;
    },
    clearForm: (state) => {
      state.departments.form = initialState.departments.form;
      state.job_titles.form = initialState.job_titles.form;
    },
    setMyEmployeeDepartment: (state, { payload }) => {
      state.my_department_employees.list = payload.data;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setDataTable,
  setJobTitle,
  setForm,
  clearForm,
  myDepartmentEmployees,
  setLoadingForm,
} = departmentsJobTitlesSlice.actions;

export default departmentsJobTitlesSlice.reducer;

export const Department = {
  getAll: (params) => async (dispatch) => {
    try {
      dispatch(setLoading("departments"));
      const res = await departmentApi.getAll(params);
      dispatch(
        setDataTable({
          key: "departments",
          value: res.data,
        }),
      );
      dispatch(setLoading("departments"));
    } catch (err) {
      dispatch(setLoading("departments"));
      throw new Error(err);
    }
  },
  create: (data) => async (dispatch) => {
    try {
      dispatch(setLoading("departments"));
      await departmentApi.create({
        name: data.name,
        belongs_to: data.belongs_to.id,
        manager_user_id: data.manager_user_id.id,
        need_approval_over_time: data.need_approval_over_time ? "1" : "0",
      });
      // dispatch(showNotification({
      //     message: res.data.message,
      //     type: "success"
      // }));
      dispatch(setDialog());
      dispatch(
        Department.getAll({
          skip: 0,
          take: 100,
        }),
      );
      dispatch(setLoading("departments"));
    } catch (err) {
      dispatch(setLoading("departments"));
      dispatch(
        showNotification({
          message: err.response.data.message,
          type: "error",
        }),
      );
      throw new Error(err);
    }
  },
  update: (id, data) => async (dispatch) => {
    try {
      // dispatch(setLoading('departments'));
      await departmentApi.update(data.id, {
        name: data.name,
        belongs_to: data.belongs_to ? data.belongs_to.id : null,
        manager_user_id: data.manager_user_id.id,
        need_approval_over_time: data.need_approval_over_time ? "1" : "0",
      });
      dispatch(
        Department.getAll({
          skip: 0,
          take: 100,
        }),
      );
      dispatch(setDialog());

      // dispatch(showNotification({
      //     message: res.data.message,
      //     type: "success"
      // }));
      // dispatch(setLoading('departments'));
    } catch (err) {
      dispatch(setLoading("departments"));
      throw new Error(err);
    }
  },
  getById:
    (id, toggleDialog = true) =>
    async (dispatch) => {
      try {
        dispatch(setLoading("departments"));
        const res = await departmentApi.getById(id);
        if (toggleDialog) {
          dispatch(setDialog());
        }
        dispatch(setForm(res.data));
        dispatch(setLoading("departments"));
      } catch (e) {
        dispatch(setLoading("departments"));
      }
    },
  deleteById: (id) => async (dispatch) => {
    try {
      // dispatch(setLoading('departments'));
      await departmentApi.delete(id);
      dispatch(
        Department.getAll({
          skip: 0,
          take: 100,
        }),
      );
    } catch (e) {
      // dispatch(setLoading('departments'))
    }
  },
  myDepartmentEmployees: (params) => async (dispatch) => {
    try {
      dispatch(setLoading("my_department_employees"));
      const res = await departmentApi.myDepartmentEmployees(params);
      dispatch(
        setDataTable({
          key: "my_department_employees",
          value: res.data,
        }),
      );
      dispatch(setLoading("my_department_employees"));
    } catch (err) {
      dispatch(setLoading("my_department_employees"));
      throw new Error(err);
    }
  },
};
export const JobTitle = {
  create: (data) => async (dispatch) => {
    try {
      dispatch(setLoading("job_titles"));
      await job_titleApi.create({
        department_id: data.id,
        name: data.name,
      });
      dispatch(
        showNotification({
          message: "تم الاضافة بنجاح",
          type: "success",
        }),
      );
      dispatch(Department.getById(data.id, false));
      dispatch(setLoading("job_titles"));
      dispatch(
        Department.getAll({
          skip: 0,
          take: 100,
        }),
      );
    } catch (err) {
      dispatch(setLoading("job_titles"));
      dispatch(
        showNotification({
          message: err.response.data.errors,
          type: "error",
        }),
      );
      throw new Error(err);
    }
  },
  update: (data) => async (dispatch) => {
    try {
      // dispatch(setLoading('departments'));
      await job_titleApi.update(data);
      dispatch(Department.getById(data.department_id, false));
      dispatch(
        showNotification({
          message: "تم التعديل بنجاح",
          type: "success",
        }),
      );
      dispatch(
        Department.getAll({
          skip: 0,
          take: 100,
        }),
      );
    } catch (err) {
      dispatch(setLoading("departments"));
      throw new Error(err);
    }
  },
  deleteById: (data) => async (dispatch) => {
    try {
      dispatch(setLoading("job_titles"));
      await job_titleApi.delete(data.job_title_id);
      dispatch(Department.getById(data.department_id, false));
      dispatch(
        Department.getAll({
          skip: 0,
          take: 100,
        }),
      );
      dispatch(setLoading("job_titles"));
    } catch (err) {
      dispatch(setLoading("job_titles"));
      throw new Error(err);
    }
  },
};
